/**
 * Comment
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';
import MobileSdkTemplate from '../MobileSdkTemplate';
import Loading from '../../Loading';
import CommentWrite from './CommentWrite';
import CommentReply from './CommentReply';
import CommentUpdate from './CommentUpdate';
import CommentVote from './CommentVote';
import CommentRemove from './CommentRemove';
import CommentReload from './CommentReload';
import CommentOrder from './CommentOrder';
import CommentHeader from './CommentHeader';
import CommentListWrap from './CommentListWrap';
import CommentReport from './CommentReport';
import CommentMore from './CommentMore';
import CommentUpload from './CommentUpload';
import CommentEmoticon from './CommentEmoticon';
import CommentImageViewer from './CommentImageViewer';
import CommentListNone from './CommentListNone';
import PrevNextArticle from '../PrevNextArticle';
import GameInfo from '../../GameInfo';
import CommentAnchor from './CommentAnchor';

class Comment {

	public commentLoaded: any;

	protected $node: any;

	protected options: any;

	protected _id: string;

	protected articleId: string;

	protected inited: boolean;

	protected template: any;

	protected commentReload: CommentReload;

	protected commentMore: CommentMore;

	protected commentOrder: CommentOrder;

	protected commentHeader: CommentHeader;

	protected commentUpload: CommentUpload;

	protected commentReply: CommentReply;

	protected commentWrite: CommentWrite;

	protected commentUpdate: CommentUpdate;

	protected commentEmoticon: CommentEmoticon;

	protected loading: Loading;

	protected commentListWrap: CommentListWrap;

	private commentVote: CommentVote;

	private commentRemove: CommentRemove;

	private commentListNone: CommentListNone;

	private writeAutoHeight: any;

	private replyAutoHeight: any;

	private commentUpdateAutoHeight: any;

	private commentReport: CommentReport;

	private viewCount: string;

	private commentCount: string;

	private btnCommentEmoticon: string;

	private commentImageViewer: CommentImageViewer;

	private commentAnchor: CommentAnchor;

	constructor( node: any, options: any ) {
		this.$node = node;

		this.options = options;

		this.$node.addClass( Config.COMMUNITY_NODE );

		this._id = this.$node.attr( 'id' );

		this.commentLoaded = new Util.Observer();

		this.articleId = options.articleId || Util.getParams().articleId;

		this.inited = false;

		if ( Util.getParams().isNotice !== '1' ) {
			this.init( node, options );
		}
	}

	public addSelector() {
		this.viewCount = `.${Config.COMMUNITY_NODE} .comment`;
		this.commentCount = `#${this._id} .commentTotalCount`;
		this.btnCommentEmoticon = `#${this._id} .btn-emoticon`;
	}

	public addMobileEvent() {
		jQuery( 'body' ).on( 'click', `#${this._id} .writerInfo`, ( evt ) => {
			const _$this = jQuery( evt.currentTarget );
			const commentId = _$this.attr( 'data-commentid' );
			location.href = Config.mobileSdk.articleWriterInfo( commentId );
			return;
		});
	}

	// @deprecated
	public setCommentUI( commentCount: string|number ) {
		// if <body> has [#ncCommunityView .comment em] node, change commentCount
		jQuery( this.viewCount ).data('count');
		this.commentHeader.setCommentCount(commentCount);
	}

	public getCommentCount() {
		const _commentCountUrl = ( Util.getParams().isNotice ) ? Config.noticeView : Config.view;
		const articleId = Config.articleId || Util.getParams().articleId;
		const viewUrl = Util.Tmpl.render({
			data: {
				articleId,
				board: Config.board,
			},
			template: _commentCountUrl,
		});

		const view: any = Util.get( viewUrl );
		const view$ = Util.from( view );
		view$.subscribe( ( data: any ) => {
			let commentCount = 0;
			data = Util.convertCamelCase( data );

			if ( data && data.article ) {
				commentCount = data.article.commentCount || 0;

				// @deprecated
				this.setCommentUI( commentCount );
			}
		}, () => {
			// reject
		});
	}

	public myLikeComment( data: any ) {
		if ( !data || data.length === 0 ) {
			return;
		}

		data.forEach( ( item: any ) =>  {
			$( `#${this._id} button.co-btn-like[data-commentid=${item}]` ).addClass( 'is-active' );
		});
	}

	public chgComment( isWrite = false, orderType = ( !Config.isShowCommentOrderType ) ?
		Config.commentOrderByDesc : Config.commentOrderByDefault ) {

		const articleId = Config.articleId || Util.getParams().articleId;
		const commentUrl = Util.Tmpl.render({
			data: {
				articleId,
				orderType,
				board: Config.board,
				size: Config.commentListSize,
			},
			template: Config.commentVote,
		});

		const comment: any = Util.get( commentUrl );
		const comment$ = Util.from( comment );
		comment$.subscribe( ( data: any ) => {

			data = Util.convertCamelCase( data );

			if ( data.listCommentEntries ) {
				data.pageNavigation = data.listCommentEntries.pageNavigation;
				data.commentList = data.listCommentEntries.commentList;
				data.likeCommentIds = data.listCommentEntries.likeCommentIds;
			}

			const body = this.template.commentList( data );
			const list = this.commentListWrap.getChildren();
			const page = data.pageNavigation;
			this.commentListWrap.appendList( body );
			list.remove();

			this.commentMore.setOrderType( orderType );

			( page.currentPage < page.lastPage ) ?
				this.commentMore.showMoreButton() :
				this.commentMore.remove();

			if ( isWrite ) {
				// writed comments - a few seconds ago
				const writingComment = this.$node.find( '.commentThread :first' );

				writingComment.find( '.date' ).text( Config.L10N.a_few_seconds_ago );
				writingComment.addClass( 'is-highlight' );

				// @TODO remove this code
				if ( Config._isHideCommentProfile ) {
					writingComment.css( 'padding-left', '18px' );
				}
			}

			this.myLikeComment( data.likeCommentIds );

			this.commentOrder.setActiveOrderType( orderType );

			if ( data.commentList.length === 0 ) {
				this.$node.find( `.commentThread` ).append( this.commentListNone.setUI() );
			}

			this.getCommentCount();
			this.goAnchor();
			this.commentLoaded.emit( data );

		}, ( data: any ) => {
			if ( data.status && data.status.toString() === '400' ) {
				location.href = Config.listPage;
			}

			if ( data.status && data.status.toString() === '401' ) {
				Config.apiError( data );
			}

			// if( data.status == 500 ){}
		});
	}

	public goAnchor() {
		const _param = Util.getParams();
		if ( _param.isMoveToComments ) {
			location.hash = 'nccommentwrap';
		}
	}

	public getCount( pagination: any ) {
		if ( !pagination ) {
			return 0;
		}

		return pagination.totalCount + pagination.replyCount;
	}

	public setPrevNext() {
		if ( Config.isShowPrevNextArticle ) {
			const prevNextArticle = new PrevNextArticle();
			prevNextArticle.setUI( this.$node, false );
		}
	}

	public setCloneViewBottom() {
		const viewBottom = jQuery( '.view-bottom' );
		if ( viewBottom.length !== 0 ) {
			// this.$node.after( viewBottom.clone() );
			viewBottom.clone( true ).appendTo( this.$node );
		}
	}

	public get( page?: string|number ) {
		// @TODO ref - It works, If type is top notice
		if ( !this.inited ) {
			if ( Config.viewBoardAlias ) {
				this.init( this.$node, this.options );
				this._get();
			} else {
				Config.viewBoardObserver.add( ( board: any ) => {
					this.init( this.$node, this.options );
					this._get();
				}, this);
			}
		} else {
			this._get();
		}
	}

	private _get() {

		this.loading.show();

		const _param = Util.getParams();

		const articleId = this.articleId || _param.articleId;

		const _orderType = ( !Config.isShowCommentOrderType ) ?
			Config.commentOrderByDesc : Config.commentOrderByDefault;

		// if This article is notice Article, it has done.
		if ( !Config.isShowNoticeComment && _param.isNotice === '1' ) {
			this.loading.hide();
			return;
		}

		const commentUrl = Util.Tmpl.render({
			data: {
				articleId,
				board: Config.board,
				size: Config.commentListSize,
				orderType: _param.orderType || _orderType,
			},
			template: Config.commentVote,
		});

		const comment: any = Util.get( commentUrl );
		const comment$ = Util.from( comment );
		comment$.subscribe( ( data: any ) => {

			const listNone = '';

			data = Util.convertCamelCase( data );

			if ( data.listCommentEntries ) {
				data.pageNavigation = data.listCommentEntries.pageNavigation;
				data.commentList = data.listCommentEntries.commentList;
				data.likeCommentIds = data.listCommentEntries.likeCommentIds;
			}

			// set comment Header UI
			const $viewCount = jQuery( this.viewCount );

			const header = ( $viewCount.length && $viewCount.data('count') ) ?
				this.commentHeader.setUI({ totalCount: Number( $viewCount.data('count') ) }) :
				this.commentHeader.setUI( data.pageNavigation || data.commentPagination );

			// set comment write textare UI
			const write = this.commentWrite.setUI();

			const order = this.commentOrder.setUI();

			// set comment List UI
			const body = this.commentListWrap.setUI( this.template.commentList( data ) );

			const more = this.commentMore.setUI();

			// merge comment Template String
			const wrapComment = this.template.comment( header + write + order + body + listNone + more );

			this.$node.append( wrapComment );

			// set comment Reply textarea UI
			const commentReply = this.commentReply.setUI();
			this.$node.append( commentReply.hide() );

			// set comment Reply textarea UI
			if ( Config.isCommentUpdate ) {
				const commentUpdate = this.commentUpdate.setUI();
				this.$node.append( commentUpdate.hide() );
			}

			// It's works, If Config.commentPlaceholder is not empty
			if ( Config.commentPlaceholder ) {
				this.commentWrite.setPlaceHolder( Config.commentPlaceholder );
			}

			if ( data.commentList.length === 0 ) {
				this.$node.find( `.commentThread` ).append( this.commentListNone.setUI() );
			}

			this.myLikeComment( data.likeCommentIds );

			// addClass(is-active)
			this.commentOrder.setActiveOrderType();

			// If it's the last page, remove more button
			if ( ( data.pageNavigation && data.pageNavigation.endPage <= 1 ) ||
					( data.commentPagination && data.commentPagination.endPage <= 1 )	) {
				this.commentMore.remove();
			}

			this.loading.hide();
			this.goAnchor();
			this.setPrevNext();
			this.setCloneViewBottom();
			this.commentLoaded.emit( data );

		}, () => {
			this.loading.hide();
			this.setPrevNext();
			this.setCloneViewBottom();
			this.commentLoaded.emit();
		});
	}

	private init( node: any, options: any ) {

		jQuery.extend( true, Config, options );

		Config.board = ( Util.getParams().isNotice === '1' && Config.viewBoardAlias ) ?
			Config.viewBoardAlias : Config.board;

		Config.commentWrite = ( options.commentWriteAPIUrl ) ?
			options.commentWriteAPIUrl : Config.commentWrite;

		Config.commentRemove = ( options.commentRemoveAPIUrl ) ?
			options.commentRemoveAPIUrl : Config.commentRemove;

		// comment list
		Config.commentVote = ( options.commentAPIUrl ) ?
			options.commentAPIUrl : Config.commentVote;

		// vote
		Config.voteComment = ( options.commentVoteAPIUrl ) ?
			options.commentVoteAPIUrl : Config.voteComment;

		// emoticons
		Config.attachedEmoticonsSize = ( options && options.attachedEmoticonsSize ) ?
			options.attachedEmoticonsSize : Config.attachedEmoticonsSize;

		Config.defaultCommentProfileImage	= ( options && options.defaultCommentProfileImage ) ?
			options.defaultCommentProfileImage : '';

		this.template = ( Config.isMobileSdk ) ?
			MobileSdkTemplate : Template;

		// lineagem, h2, fb, rk
		if ( GameInfo.isMobileSite() ) {
			Config.isCommentUpdate = true;
		}

		// like button
		this.commentVote = new CommentVote( this.$node, this.articleId );

		// remove Comment Article
		this.commentRemove = new CommentRemove( this.$node, this.articleId );
		this.commentRemove.onRemove.add( () => {
			this.getCommentCount();
		}, this );

		// comment wrap UI
		this.commentListWrap = new CommentListWrap( this.$node, this.articleId );

		// reload comment
		this.commentReload = new CommentReload( this.$node, this.articleId );
		this.commentReload.onReload.add( () => {
			this.chgComment();
		}, this );

		// more button
		this.commentMore = new CommentMore( this.$node, this.articleId );
		this.commentMore.onMore.add( ( data: any ) => {
			this.commentListWrap.appendList( this.template.commentList( data ) );
			this.myLikeComment( data.likeCommentIds );
		}, this );

		// orderby desc, orderby asc
		this.commentOrder = new CommentOrder( this.$node, this.articleId );
		this.commentOrder.onReload.add( ( orderType: any ) => {
			this.commentMore.setOrderType( orderType );
			this.chgComment( false, orderType );
		}, this );

		// comment count UI
		this.commentHeader = new CommentHeader( this.$node, this.articleId );

		// upload comment Image
		if ( Config.isCommentUpload ) {
			this.commentUpload = new CommentUpload();
			this.commentUpload.onUploaded.add( ( img: any ) => {
				const _data: any = { contents: img };
				if ( Config.currentCommentIdForUpload ) {
					_data.commentId = Config.currentCommentIdForUpload;
					this.commentReply.setCommentId( _data.commentId );
					this.commentReply.submit( _data, 'image' );
				} else {
					this.commentWrite.submit( _data, 'image' );
				}
			});

			this.commentUpload.onUploadBefore.add( ( commentId: string ) => {
				Config.currentCommentIdForUpload = commentId || '';
			});
		}

		// emoticon
		if ( Config.isCommentEmoticon ) {
			this.commentEmoticon = new CommentEmoticon( this.$node, jQuery( 'body' ) );
			this.commentEmoticon.onUpload.add( ( img: any ) => {

				if ( !img ) {
					return false;
				}

				const _data: any = { contents: img };

				if ( Config.currentCommentIdForUpload ) {
					_data.commentId = Config.currentCommentIdForUpload;
					this.commentReply.setCommentId( _data.commentId );
				}

				( Config.currentCommentIdForUpload ) ?
					this.commentReply.submit( _data, 'emoticon' ) :
					this.commentWrite.submit( _data, 'emoticon' );
			});
		}

		// comment list none UI
		this.commentListNone = new CommentListNone( this.$node );

		// write comment
		this.commentWrite = new CommentWrite( this.$node, this.articleId );
		this.commentWrite.onWrite.add( ( _data: any ) => {
			this.chgComment( true, Config.commentOrderByDesc );

			if ( _data.commentResourceType !== 'emoticon' &&
				_data.commentResourceType !== 'image' ) {
				this.commentWrite.clear();
			}

			if ( this.writeAutoHeight ) {
				this.writeAutoHeight.reset();
			}

			this.commentListNone.remove();
		}, this );

		// comment Reply
		this.commentReply = new CommentReply( this.$node, this.articleId );
		this.commentReply.onReply.add( () => {
			this.getCommentCount();

			if ( this.replyAutoHeight ) {
				this.replyAutoHeight.reset();
			}

		}, this );
		this.commentReply.onUploadBefore.add( ( commentId: string ) => {
			Config.currentCommentIdForUpload = commentId;
		}, this );

		if ( Config.isCommentUpdate ) {
			this.commentUpdate = new CommentUpdate( this.$node, this.articleId );
			this.commentUpdate.onReply.add( () => {
				// resolve
			}, this );
			this.commentUpdate.onUploadBefore.add( ( commentId: string ) => {
				Config.currentCommentIdForUpload = commentId;
			}, this );
		}

		// comment report UI
		this.commentReport = new CommentReport( this.$node, jQuery( 'body' ), this.articleId );

		// loading spinner
		this.loading = new Loading( this.$node );
		this.loading.setUI();

		// comment Image viewer
		this.commentImageViewer = new CommentImageViewer();

		// comment Anchor
		this.commentAnchor = new CommentAnchor();

		this.addSelector();

		if ( Config.isMobileSdk ) {
			this.addMobileEvent();
		}

		this.commentLoaded.add( () => {

			if ( this.commentUpload ) {
				this.commentUpload.addEventFrameload();
			}

			if ( !this.writeAutoHeight ) {
				this.writeAutoHeight = new Util.TextAreaAutoHeight( this.commentWrite.getNode(),
				this.commentWrite.getNode().parent( 'div' ), 50, 1.5, 420 /* 14 * 1.5 * 20 */ );
			}

			if ( !this.replyAutoHeight ) {
				this.replyAutoHeight = new Util.TextAreaAutoHeight( this.commentReply.getNode(),
				this.commentReply.getNode().parent( 'div' ), 50, 1.5, 420 );
			}

			if ( Config.isCommentUpdate && !this.commentUpdateAutoHeight ) {
				this.commentUpdateAutoHeight = new Util.TextAreaAutoHeight( this.commentUpdate.getNode(),
				this.commentUpdate.getNode().parent( 'div' ), 50, 1.5, 420 );
			}

			// goToComment
			this.commentAnchor.goToComment( 'onCommentLoaded' );

		}, this );

		this.inited = true;
	}
}

export default Comment;
